import * as React from "react";
const SvgSettings20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M7.74 0h4.52l.63 2.271c.18.067.357.14.53.22l2.053-1.16 3.196 3.196-1.16 2.052c.08.174.153.35.22.53L20 7.74v4.521l-2.271.63c-.067.18-.14.357-.22.53l1.16 2.053-3.196 3.196-2.052-1.16c-.174.08-.35.153-.53.22L12.26 20H7.74l-.63-2.271a8.201 8.201 0 0 1-.53-.22l-2.053 1.16-3.196-3.196 1.16-2.052a8.19 8.19 0 0 1-.22-.53L0 12.26V7.74l2.271-.63c.067-.18.14-.357.22-.53L1.33 4.526 4.526 1.33 6.58 2.49c.174-.08.35-.153.53-.22L7.74 0Zm1.52 2-.514 1.85-.53.158c-.417.124-.815.29-1.19.493l-.487.264-1.673-.945L3.82 4.866l.945 1.673-.264.487c-.203.375-.37.773-.493 1.19l-.158.53L2 9.26v1.48l1.85.514.158.53c.124.417.29.815.493 1.19l.264.487-.945 1.673 1.046 1.046 1.673-.945.487.264c.375.203.773.37 1.19.493l.53.157L9.26 18h1.48l.514-1.85.53-.158c.417-.124.815-.29 1.19-.494l.487-.263 1.673.945 1.046-1.046-.945-1.673.264-.487c.203-.375.37-.773.493-1.19l.157-.53L18 10.74V9.26l-1.85-.514-.158-.53a6.208 6.208 0 0 0-.494-1.19l-.263-.487.945-1.673-1.046-1.046-1.673.945-.487-.264a6.204 6.204 0 0 0-1.19-.493l-.53-.158L10.74 2H9.26ZM10 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgSettings20Px;
